<template>
  <div>
    <div class="resource-detail" v-if="resource">
      <!-- 返回按钮和标题 -->
      <div class="detail-header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack"
        >返回列表
        </el-button
        >
        <h1>
          {{ baseTypeData.name }}
          <span class="resource-category">{{ baseTypeData.categoryName }}</span>
        </h1>
      </div>

      <!-- 主要内容区域 -->
      <div class="detail-content-vertical">
        <!-- 上方基本信息卡片 -->
        <!-- 基本信息卡片部分修改为左右结构 -->
        <el-card class="basic-info-card">
          <div slot="header" class="card-header">
            <span>基本信息</span>
          </div>
          <div class="info-content-horizontal">
            <!-- 左侧价格和时间信息 -->
            <div class="left-info">
              <div class="info-item">
                <div class="info-label">当前价格</div>
                <div class="info-value price">
                  ¥{{ baseTypeData.price }}{{ baseTypeData.unit }}
                </div>
                <div class="info-extra">
                  <span :class="getChangeClass(baseTypeData.mom)"
                  >{{ formatChange(baseTypeData.mom) }} 环比</span
                  >
                </div>
              </div>

              <div class="info-item">
                <div class="info-label">最新更新时间</div>
                <div class="info-value">{{ baseTypeData.updateTime }}</div>
              </div>
            </div>

            <!-- 右侧资源描述 -->
            <div class="right-description">
              <div class="info-item">
                <div class="info-label">资源描述</div>
                <div class="info-value">
                  {{ baseTypeData.description || '暂无描述信息' }}
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 下方价格趋势卡片 -->
        <el-card class="price-trend-card">
          <div slot="header" class="card-header">
            <span>{{
                trendRange === 'last'
                    ? '最新价格趋势'
                    : `价格趋势 (近${parseInt(this.trendRange)}${'个月'})`
              }}</span>
            <div class="trend-actions">
              <el-button-group>
                <el-button
                    size="mini"
                    :type="trendRange === 'last' ? 'primary' : ''"
                    @click="changeTrendRange('last')"
                >最新
                </el-button
                >
                <el-button
                    size="mini"
                    :type="trendRange === '1m' ? 'primary' : ''"
                    @click="changeTrendRange('1m')"
                >1个月
                </el-button
                >
                <el-button
                    size="mini"
                    :type="trendRange === '6m' ? 'primary' : ''"
                    @click="changeTrendRange('6m')"
                >6个月
                </el-button
                >
                <el-button
                    size="mini"
                    :type="trendRange === '12m' ? 'primary' : ''"
                    @click="changeTrendRange('12m')"
                >12个月
                </el-button
                >
              </el-button-group>
            </div>
          </div>
          <div class="trend-chart-container">
            <price-trend-chart
                :priceData="currentTrendData"
                :color="resource.color"
                :dateData="originTrendData"
            ></price-trend-chart>
          </div>
        </el-card>
        <!-- 下方价格趋势卡片 -->
        <el-card class="price-trend-card">
          <div slot="header" class="card-header">
            <span>趋势分析</span>
          </div>
          <div class="trend-chart-trends">
           {{ baseTypeData.trendDescription || '暂无趋势分析信息' }}
          </div>
        </el-card>
      </div>
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <el-skeleton :rows="6" animated/>
      </div>

      <!-- 错误状态 -->
      <div v-else-if="error" class="error-container">
        <el-alert
            title="加载资源信息失败"
            type="error"
            :description="error"
            show-icon
            :closable="false"
        />
        <el-button type="primary" @click="fetchResourceData">重试</el-button>
      </div>
    </div>
    <el-skeleton v-else :rows="24" animated/>
  </div>
</template>

<script>
import PriceTrendChart from './PriceTrendChart.vue';
import {
  fetchResourceById,
  fetchRelatedResources,
} from '@/API/resource/resource';
import {scrollTop} from '@/util/scrollTop';
import {
  getWasteSubDetail,
  getWasteSubTrend,
  getSubCategoryTrend,
} from '@/API/price/price.js';
import fecha from 'element-ui/src/utils/date';

export default {
  components: {
    PriceTrendChart,
  },
  data() {
    return {
      resourceId: this.$route.params.id,
      resource: {},
      relatedResources: [],
      loading: false,
      error: null,
      trendRange: 'last',
      activeGuide: ['standard', 'classification', 'process', 'notice'],
      originTrendDataList: {},
    };
  },
  computed: {
    currentTrendData() {
      if (!this.resource) return {};
      switch (this.trendRange) {
        case 'last':
          return this.resource.trendDataLast || [];
        case '1m':
          return this.resource.trendData1m || [];
        case '6m':
          return this.resource.trendData6m || [];
        case '12m':
          return this.resource.trendData12m || [];
        default:
          return this.resource.trendDataLast || [];
      }
    },
    originTrendData() {
      if (!this.originTrendDataList) return {};
      switch (this.trendRange) {
        case 'last':
          return this.originTrendDataList.trendDataLast || [];
        case '1m':
          return this.originTrendDataList.trendData1m || [];
        case '6m':
          return this.originTrendDataList.trendData6m || [];
        case '12m':
          return this.originTrendDataList.trendData12m || [];
        default:
          return this.originTrendDataList.trendDataLast || [];
      }
    },
    trendRangeText() {
      switch (this.trendRange) {
        case 'last':
          return '最新';
        case '1m':
          return '近1个月';
        case '6m':
          return '近6个月';
        case '12m':
          return '近12个月';
        default:
          return '';
      }
    },
    trendStats() {
      const data = this.currentTrendData;
      if (!data || data.length === 0) {
        return {
          max: '--',
          min: '--',
          avg: '--',
          maxDate: '--',
          minDate: '--',
        };
      }

      const max = Math.max(...data);
      const min = Math.min(...data);
      const avg = (data.reduce((a, b) => a + b, 0) / data.length).toFixed(0);

      // 模拟日期计算
      const now = new Date();
      let maxDate, minDate;

      if (this.trendRange === '6m') {
        maxDate = new Date(
            now.setMonth(now.getMonth() - data.length + data.indexOf(max)),
        ).toLocaleDateString('zh-CN', {month: 'long', day: 'numeric'});
        minDate = new Date(
            now.setMonth(now.getMonth() - data.length + data.indexOf(min)),
        ).toLocaleDateString('zh-CN', {month: 'long', day: 'numeric'});
      } else {
        maxDate = new Date(
            now.setMonth(now.getMonth() - data.length + data.indexOf(max)),
        ).toLocaleDateString('zh-CN', {year: 'numeric', month: 'long'});
        minDate = new Date(
            now.setMonth(now.getMonth() - data.length + data.indexOf(min)),
        ).toLocaleDateString('zh-CN', {year: 'numeric', month: 'long'});
      }

      return {
        max: max.toFixed(0),
        min: min.toFixed(0),
        avg,
        maxDate,
        minDate,
      };
    },
  },
  created() {
    scrollTop();
    this.fetchResourceData();
  },
  props: {
    cardId: {
      type: Number,
      default: 1,
    },
    wasteSubId: {
      type: Number,
    },
    baseTypeData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    cardId: {
      handler(newId) {
        if (newId) {
          this.resourceId = newId;
          // this.fetchResourceData();
        }
      },
      immediate: true,
    },
    wasteSubId: {
      handler(val) {
        console.log('4444444444', val, this.baseTypeData);
      },
      immediate: true,
    },
  },
  methods: {
    async fetchResourceData() {
      function getLastRange(num = 0) {
        if (num == 0) {
          return 'last';
        } else {
          const end = new Date();
          const start = new Date();
          let days = 30 * num - 1;
          start.setDate(end.getDate() - days); // 减29天，因为包含今天
          return {
            beginDate: fecha.format(new Date(start), 'yyyy-MM-dd'),
            endDate: fecha.format(new Date(end), 'yyyy-MM-dd'),
          };
        }
      }

      let resourceList = [];
      let dateRangList = [0, 1, 6, 12];
      let keyList = [
        'trendDataLast',
        'trendData1m',
        'trendData6m',
        'trendData12m',
      ];
      for (let i = 0; i < 4; i++) {
        resourceList.push(
            this.getSubTrend(getLastRange(dateRangList[i]), keyList[i]),
        );
      }

      this.loading = true;
      this.error = null;
      try {
        Promise.all(resourceList).then((res) => {
          console.log(
              '124525326363637373',
              this.resource,
              this.originTrendDataList,
              res,
              this.baseTypeData.trendData,
          );
        });
      } catch (err) {
        this.error = err.message || '加载数据失败，请稍后重试';
        console.error('获取资源数据失败:', err);
      } finally {
        this.loading = false;
      }
    },
    changeTrendRange(range) {
      this.trendRange = range;
      console.log(range, 'rangerangerange');
    },
    goBack() {
      this.$emit('goBack', false);
    },
    goToDetail(id) {
      this.$router.push({name: 'ResourceDetail', params: {id}});
    },
    getChangeClass(change) {
      return change >= 0 ? 'negative' : 'positive';
    },
    formatChange(change) {
      return change >= 0
          ? `↑ ${change.toFixed(2)}%`
          : `↓ ${Math.abs(change).toFixed(2)}%`;
    },
    // 获取对应期间的价格数据
    async getSubTrend(params, key) {
      if (params == 'last') {
        let lastRes = await getSubCategoryTrend(this.wasteSubId);
        this.$set(this.resource, key, []);
        this.$set(this.originTrendDataList, key, []);
        let index = lastRes.data.length - 10;
        let startIndex = Math.max(index, 0);
        let tempRes = lastRes.data.slice(startIndex);
        tempRes.forEach((item) => {
          this.resource[key].push(item.price);
          this.originTrendDataList[key].push(item.priceDate);
        });
        console.log('lastRes', lastRes);
        return lastRes;
      } else {
        let res = await getSubCategoryTrend(this.wasteSubId, params);
        console.log('key', key, res);
        if (res.code == 200) {
          this.$set(this.resource, key, []);
          this.$set(this.originTrendDataList, key, []);
          let index = res.data.length - 10;
          let startIndex = Math.max(index, 0);
          let tempRes = res.data.slice(startIndex);
          tempRes.forEach((item, index) => {
            if (index < 10) {
              this.resource[key].push(item.price);
              this.originTrendDataList[key].push(item.priceDate);
            }
          });
        }
        return res;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .resource-detail {
    max-width: unset !important;

    .detail-header {
      /deep/ .el-button i {
        font-size: 14px !important;
      }

      /deep/ .el-button span {
        font-size: 14px !important;
      }

      h1 {
        font-size: 16px !important;
      }

      span {
        font-size: 14px !important;
      }
    }

    .left-info {
      width: 30% !important;
    }

    .card-header {
      display: unset !important;
      justify-content: unset !important;

      span {
        font-size: 16px !important;
      }
    }

    /deep/ .el-card__header {
      padding: 0px 20px 10px 20px !important;
    }

    .info-item {
      .info-label {
        font-size: 14px !important;
      }

      .info-value {
        font-size: 14px !important;
      }

      .info-extra {
        span {
          font-size: 14px !important;
        }
      }
    }

    .trend-chart-container {
      height: 300px !important;
    }


    /deep/.trend-actions span {
        font-size: 14px !important;
    }
  }
}


.resource-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .loading-container,
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;

    .el-alert {
      margin-bottom: 20px;
      max-width: 600px;
    }
  }

  .detail-header {
    margin-bottom: 30px;

    ::v-deep .el-button {
      i,
      span {
        font-size: 18px;
      }
    }

    h1 {
      font-size: 28px;
      color: #2c3e50;
      margin-top: 10px;

      .resource-category {
        font-size: 20px;
        background: #f0f2f5;
        color: #606266;
        padding: 4px 10px;
        border-radius: 4px;
        margin-left: 10px;
      }
    }
  }

  /* 上下布局样式 */

  .detail-content-vertical {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .basic-info-card,
    .price-trend-card {
      width: 100%;
    }

    /* 基本信息卡片样式保持不变 */

    .basic-info-card {
      .card-header {
        font-weight: bold;
        font-size: 20px;
      }

      .info-content-horizontal {
        display: flex;
        gap: 30px; /* 左右两部分之间的间距 */

        .left-info {
          width: 15%; /* 左侧占40%宽度 */
          display: flex;
          flex-direction: column;
          gap: 20px; /* 上下两项之间的间距 */

          .info-item {
            margin-bottom: 0px; /* 移除原来的底部间距 */
          }
        }

        .right-description {
          flex: 1; /* 右侧占剩余宽度 */

          .info-item {
            height: 100%;
            display: flex;
            flex-direction: column;

            .info-value {
              flex: 1;
              padding: 10px;
              // background: #f9f9f9;
              // border-radius: 4px;
              // border: 1px solid #ebeef5;
            }
          }
        }

        /* 保持原有字体大小和颜色 */

        .info-label {
          font-size: 18px;
          color: #909399;
          margin-bottom: 6px;
        }

        .info-value {
          font-size: 18px;
          color: #303133;

          &.price {
            font-size: 24px;
            font-weight: bold;
            color: #ff6b6b;
          }
        }

        .info-extra {
          span {
            font-size: 13px;
            margin-right: 15px;

            &.positive {
              font-size: 16px;
              color: #67c23a;
            }

            &.negative {
              color: #f56c6c;
            }
          }
        }
      }
    }

    /* 价格趋势卡片样式保持不变 */

    .price-trend-card {
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        font-size: 20px;

        .trend-actions {
          ::v-deep span {
            font-size: 16px;
          }
        }
      }

      .trend-chart-container {
        height: 300px;
        margin: 10px 0;
      }
      .trend-chart-trends {
        font-size: 18px;
      }
    }
  }

  .related-resources {
    margin-top: 40px;

    h3 {
      font-size: 18px;
      color: #303133;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeef5;
    }

    .resource-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 15px;

      .related-card {
        cursor: pointer;
        transition: transform 0.3s;

        &:hover {
          transform: translateY(-5px);
        }

        .card-header {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .resource-icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            color: white;
            font-size: 16px;
          }

          .resource-name {
            font-size: 16px;
            font-weight: bold;
            color: #2c3e50;
          }
        }

        .price-section {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .current-price {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
          }

          .price-change {
            font-size: 14px;

            &.positive {
              color: #67c23a;
            }

            &.negative {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
